<template>
  <div class="page-box">
    <!--查询条件 -->
    <query-condition-box class="header">
      <datePicker :hasCurrent="1" @changeDate="changeDate"></datePicker>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="exportList"
        >导出
      </el-button>
    </query-condition-box>
    <!-- 内容展示 -->
    <div class="result-container" v-loading="loading">
      <h5 class="content-title">交易概况</h5>
      <div class="trade-overview">
        <div class="trade-info">
          <div class="info-content">
            <p class="info-name">
              <span>{{ tradeInfo[0].tradeName }}</span>
              <el-popover
                placement="top"
                width="180"
                trigger="hover"
                :content="tradeInfo[0].tradeDesc"
              >
                <div slot="reference" class="question-text"></div>
              </el-popover>
            </p>
            <h5 class="info-value">{{ tradeInfo[0].tradeValue }}</h5>
          </div>
          <div class="right-info">
            <div class="info-trapezoid"></div>
            <div class="info-conversion-rate">
              <div class="conversion-info">
                <p>
                  <span>{{ tradeInfo[4].tradeName }}</span>
                  <el-popover
                    placement="top"
                    width="180"
                    trigger="hover"
                    :content="tradeInfo[4].tradeDesc"
                  >
                    <div slot="reference" class="question-text"></div>
                  </el-popover>
                </p>
                <h5>{{ tradeInfo[4].tradeValue }}%</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="trade-info">
          <div
            v-for="item in tradeInfo.slice(1, 4)"
            :key="item.id"
            class="info-content"
          >
            <p class="info-name">
              <span>{{ item.tradeName }}</span>
              <el-popover
                placement="top"
                width="180"
                trigger="hover"
                :content="item.tradeDesc"
              >
                <div slot="reference" class="question-text"></div>
              </el-popover>
            </p>
            <h5 class="info-value">{{ item.tradeValue }}</h5>
          </div>
        </div>
      </div>
      <p class="update-text">每日11:00更新昨日数据</p>
      <h5 class="content-title">趋势图</h5>
      <div class="trade-line">
        <ul class="type-list">
          <li
            v-for="item in tradeInfo"
            :key="item.id"
            class="type-li"
            :class="{ 'current-type': currentType === item.id }"
            @click="changeLineType(item.id)"
          >
            {{ item.tradeName }}
          </li>
        </ul>
        <div id="main"></div>
      </div>
      <h5 class="content-title">交易地域分布</h5>
      <div class="trade-region">
        <div class="china-map" id="map"></div>
        <div class="region-rank">
          <ul class="rank-list">
            <li class="rank-list-header">
              <div class="header1">排名</div>
              <div class="header2">地区</div>
              <div class="header3">{{ shopOrStudioTag }}访客数</div>
              <div class="header4">支付人数</div>
            </li>
            <li
              class="rank-li"
              v-for="(item, index) in rankList"
              :key="item.provinceId"
            >
              <div class="rank-no">
                <img
                  v-if="index === 0"
                  src="../../assets/images/pc-decoration/rank-icon1.png"
                  alt=""
                />
                <img
                  v-else-if="index === 1"
                  src="../../assets/images/pc-decoration/rank-icon2.png"
                  alt=""
                />
                <img
                  v-else-if="index === 2"
                  src="../../assets/images/pc-decoration/rank-icon3.png"
                  alt=""
                />
                <p v-else>{{ index + 1 }}</p>
              </div>
              <div class="rank-name" :title="item.name">
                {{ item.name }}
              </div>
              <div class="rank-info">{{ item.value }}</div>
              <div class="rank-info2">{{ item.shopDownloadCnt }}</div>
            </li>
            <li v-if="!rankList.length" class="not-data">暂无数据</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/assets/js/api";
import * as echarts from "echarts";
import mapJson from "@/assets/json/china.json";
import datePicker from "../../components/common/date-picker.vue";
export default {
  name: "ShopCenterAdminWebTradeData",

  data() {
    return {
      // 查询参数
      queryParams: {
        from: "",
        to: "",
      },
      tradeInfo: [
        {
          id: 1,
          tradeName: "访客数",
          tradeValue: 0,
          tradeDesc: "筛选时间段内，访问的用户数。",
        },
        {
          id: 2,
          tradeName: "支付人数",
          tradeValue: 0,
          tradeDesc:
            "筛选时间段内，所有资料、视频累计成交的用户数（包括免费内容的订单）。",
        },
        {
          id: 3,
          tradeName: "支付金额",
          tradeValue: 0,
          tradeDesc: "筛选时间段内，支付成功的金额总和。",
        },
        {
          id: 4,
          tradeName: "客单价",
          tradeValue: 0,
          tradeDesc: "筛选时间段内，支付金额/支付人数。",
        },
        {
          id: 5,
          tradeName: "访客支付转化率",
          tradeValue: 0,
          tradeDesc: "筛选时间段内，支付人数/访客数。",
        },
      ], // 交易概况数据
      loading: false,
      currentType: 1, // 当前趋势折线图类型
      shopVisitorCntList: [], // 访客数数据列表
      shopDownloadCntList: [], // 支付人数数据列表
      saleNumList: [], // 支付金额数据列表
      unitPriceList: [], // 客单价数据列表
      conversionList: [], // 访客支付转化率数据列表
      rankList: [], // 地图省份排行列表
    };
  },
  components: {
    datePicker,
  },
  computed: {
    // 店铺或工作室
    shopOrStudioTag() {
      return this.$store.getters["user/shopOrStudioTag"];
    },
  },
  created() {
    // 初始化 tradeInfo 数据，使用 shopOrStudioTag
    this.updateTradeInfoText();
  },
  mounted() {},
  methods: {
    // 更新 tradeInfo 文案
    updateTradeInfoText() {
      this.tradeInfo[0].tradeName = `${this.shopOrStudioTag}访客数`;
      this.tradeInfo[0].tradeDesc = `筛选时间段内，访问${this.shopOrStudioTag}的用户数。`;
      this.tradeInfo[4].tradeDesc = `筛选时间段内，支付人数/${this.shopOrStudioTag}访客数。`;
    },
    // 切换时间段
    changeDate(e) {
      this.queryParams.from = e.startTime;
      this.queryParams.to = e.endTime;
      this.queryList();
    },
    // 切换折线图类型
    changeLineType(type) {
      // console.log("折线图类型---", type);
      this.currentType = type;
      switch (this.currentType) {
        case 1:
          this.showData(this.shopVisitorCntList);
          break;
        case 2:
          this.showData(this.shopDownloadCntList);
          break;
        case 3:
          this.showData(this.saleNumList);
          break;
        case 4:
          this.showData(this.unitPriceList);
          break;
        case 5:
          this.showData(this.conversionList);
          break;
      }
    },
    // 获取交易数据
    async queryList() {
      this.loading = true;
      const { result } = await this.$axios.post(
        api.dataAnalysis.getTradeData,
        this.queryParams
      );
      if (result) {
        const {
          shopVisitorCnt, // 访客数
          shopVisitorCntList, // 访客数数据列表
          shopDownloadCnt, // 支付人数
          shopDownloadCntList, // 支付人数数据列表
          saleNum, // 支付金额
          saleNumList, // 支付金额数据列表
          unitPrice, // 客单价
          unitPriceList, // 客单价数据列表
          conversion, // 访客支付转化率
          conversionList, // 访客支付转化率数据列表
        } = result;
        this.tradeInfo[0].tradeValue = shopVisitorCnt;
        this.tradeInfo[1].tradeValue = shopDownloadCnt;
        this.tradeInfo[2].tradeValue = saleNum.toFixed(2);
        this.tradeInfo[3].tradeValue = unitPrice.toFixed(2);
        this.tradeInfo[4].tradeValue = conversion.toFixed(2);
        this.shopVisitorCntList = shopVisitorCntList;
        this.shopDownloadCntList = shopDownloadCntList;
        // 下面三类数据需要除以100 保留两位小数
        this.saleNumList = saleNumList.map((item) => {
          return {
            time: item.time,
            value: (item.value / 100).toFixed(2),
          };
        });
        this.unitPriceList = unitPriceList.map((item) => {
          return {
            time: item.time,
            value: (item.value / 100).toFixed(2),
          };
        });
        this.conversionList = conversionList.map((item) => {
          return {
            time: item.time,
            value: (item.value / 100).toFixed(2),
          };
        });
      }
      // 渲染折线数据 默认渲染店铺访客数
      this.showData(this.shopVisitorCntList);
      // 获取地图省份数据
      await this.getProviceList();
      this.loading = false;
    },
    // 获取地图省份数据
    async getProviceList() {
      const { result } = await this.$axios.post(
        api.dataAnalysis.getProvinceData,
        this.queryParams
      );
      if (result.length > 0) {
        // 获取访客数的最大值
        const maxValue = Math.max.apply(
          Math,
          result.map((item) => item.value)
        );
        // 获取排行前十的省份
        this.rankList = result.slice(0, 10);
        // 渲染地图省份数据
        this.showMap(result, maxValue);
      } else {
        this.rankList = [];
        this.showMap([]);
      }
    },
    // 渲染折线图
    showData(dataList) {
      let myChart = echarts.getInstanceByDom(document.getElementById("main"));
      if (!myChart) {
        myChart = echarts.init(document.getElementById("main"));
      }
      var option;
      option = {
        tooltip: {
          trigger: "axis",
          valueFormatter: (value) => {
            if (this.currentType === 5) {
              return value + "%";
            } else {
              return value;
            }
          }, // hover提示框展示的内容值
        },
        xAxis: {
          data: dataList.map((item) => item.time),
        },
        yAxis: {},
        series: [
          {
            data: dataList.map((item) => item.value),
            type: "line",
            name: this.tradeInfo.find((item) => item.id === this.currentType)
              .tradeName,
            // smooth: true,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    // 渲染地图
    showMap(dataList, maxValue = 10000) {
      // 判断是否已经存在实例 避免重复注册
      let myChart = echarts.getInstanceByDom(document.getElementById("map"));
      if (!myChart) {
        myChart = echarts.init(document.getElementById("map"));
      }
      echarts.registerMap("china", mapJson); // 注册地图
      var option;
      option = {
        // 提示框组件
        tooltip: {
          trigger: "item", // 触发类型-数据项图形hover触发
          formatter: (params) => {
            // 屏蔽边境线hover时的提示框
            if (!params.name.length) return "";
            // 正常省份hover时的提示框
            return `${params.name}：${params.value || 0}人`;
          }, // hover提示框展示的内容
        },
        // 视觉映射组件
        visualMap: {
          orient: "horizontal", // 显示方式-水平
          left: "center", // 距离容器左侧的位置-居中
          min: 0, // 数据最小值
          max: maxValue, // 数据最大值
          itemHeight: 200, // 组件高度-200px(设置显示方式为水平之后，组件高度即为宽度)
          inRange: {
            color: ["#c2e9ff", "#2662a9"], // 范围颜色-从小到大渐变色
          },
          hoverLink: false, // 是否启用数据项图形hover时的联动高亮效果。
          // text: ["高", "低"], // 组件两侧的文本
        },
        series: [
          {
            name: "中国", // 地图名称
            type: "map", // 系列类型-地图
            map: "china", // 地图类型-与registerMap注册地图的名字相同
            roam: false, // 是否开启鼠标缩放和平移漫游
            zoom: 1.08, // 当前视角的缩放比例
            select: {
              disabled: true, // 数据项图形是否能被选中
            },
            label: {
              normal: {
                show: false, // 是否在数据图形上展示省份名称
              },
            },
            emphasis: {
              // disabled: true, // 是否对应的鼠标悬浮效果
            },
            data: dataList,
          },
        ],
      };
      option && myChart.setOption(option, true);
    },
    // 导出数据
    exportList() {
      window.open(
        `https://shopcenter.xkw.com/${api.dataAnalysis.exportData}?from=` +
          this.queryParams.from +
          "&to=" +
          this.queryParams.to +
          "&shopId=" +
          this.$store.state.user.userInfo.shopId +
          "&dataType=8" +
          "&shopType=" +
          this.$store.state.user.userInfo.shopTypeId
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.result-container {
  padding: 47px 60px 63px;
  background: #fff;
  border-radius: 5px;
  .content-title {
    margin-bottom: 40px;
    color: #3a3d4b;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px; /* 100% */
  }
  .trade-overview {
    // display: inline-block;
    position: relative;
    .trade-info {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 65%;
      min-width: 700px;
      // max-width: 1180px;
      height: 100px;
      padding: 0px 80px;
      border-radius: 5px;
      border: 1px solid #dddfe6;
      background: #fafafa;
      &:nth-child(2) {
        margin-top: -1px;
      }
      .info-content {
        margin-right: 15%;
        .info-name {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          & > span {
            color: #606266;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 14px; /* 100% */
          }
          .question-text {
            width: 16px;
            height: 16px;
            margin-left: 5px;
            background: url("../../assets/images/operateData/question-icon.png")
              no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }
        }
        .info-value {
          margin-top: 15px;
          color: #3a3d4b;
          text-align: left;
          font-size: 34px;
          font-style: normal;
          font-weight: 700;
          line-height: 34px; /* 100% */
        }
      }
    }
    .right-info {
      position: absolute;
      top: -5px;
      right: -220px;
      z-index: 999;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .info-trapezoid {
        width: 242px;
        height: 212px;
        background: url("../../assets/images/operateData/trade-trapezoid.png")
          no-repeat;
        background-size: 100% 100%;
      }
      .info-conversion-rate {
        position: relative;
        left: -50px;
        width: 154px;
        height: 173px;
        background: url("../../assets/images/operateData/conversion-rate-bg.png")
          no-repeat;
        background-size: 100% 100%;
        .conversion-info {
          position: absolute;
          top: 50%;
          right: -80px;
          transform: translateY(-50%);
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          padding: 5px 0;
          background: #fff;
          & > p {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 10px;
            color: #606266;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 14px; /* 100% */
            .question-text {
              width: 16px;
              height: 16px;
              margin-left: 5px;
              background: url("../../assets/images/operateData/question-icon.png")
                no-repeat;
              background-size: 100% 100%;
              cursor: pointer;
            }
          }
          h5 {
            color: #3a3d4b;
            text-align: left;
            font-size: 34px;
            font-style: normal;
            font-weight: 700;
            line-height: 34px; /* 100% */
          }
        }
      }
    }
  }
  .update-text {
    margin: 30px 0;
    color: #616366;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    text-align: center;
    line-height: 14px; /* 100% */
  }
  .trade-line {
    .type-list {
      display: flex;
      align-items: center;
      justify-content: center;
      .type-li {
        display: flex;
        height: 22px;
        padding: 5px 15px;
        justify-content: center;
        align-items: center;
        color: #616367;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 12px; /* 100% */
        border-top: 1px solid #e2e2e2;
        border-bottom: 1px solid #e2e2e2;
        border-right: 1px solid #e2e2e2;
        cursor: pointer;
        &:first-child {
          border-left: 1px solid #e2e2e2;
          border-radius: 4px 0 0 4px;
        }
        &:last-child {
          border-radius: 0 4px 4px 0;
        }
      }
      .current-type {
        background: #6384f7;
        color: #fff;
        border-color: #6384f7 !important;
      }
    }
    #main {
      height: 400px;
    }
  }
  .trade-region {
    display: flex;
    align-items: center;
    justify-content: center;
    .china-map {
      width: 40%;
      height: 476px;
      margin-right: 10%;
    }
    .region-rank {
      width: 40%;
      height: 450px;
      .rank-list {
        .rank-list-header {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          height: 36px;
          border-bottom: 1px solid #e6ebf4;
          background: #f3f7fd;
          & > div {
            color: #606266;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 12px; /* 100% */
          }
          .header1 {
            width: 15%;
            text-align: center;
          }
          .header2 {
            width: 40%;
            text-align: center;
          }
          .header3 {
            width: 25%;
            text-align: center;
          }
          .header4 {
            width: 20%;
            text-align: center;
          }
        }
        .rank-li {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          height: 42px;
          border-bottom: 1px solid #e6ebf4;
          & > div {
            color: #3a3d4b;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
            white-space: nowrap;
          }
          .rank-no {
            width: 11%;
            padding: 0 2%;
            img {
              width: 14px;
              height: 16px;
            }
            p {
              color: #3a3d4b;
              font-size: 12px;
              font-style: normal;
              font-weight: 400;
              line-height: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .rank-name {
            width: 36%;
            padding: 0 2%;
          }
          .rank-info {
            width: 21%;
            padding: 0 2%;
          }
          .rank-info2 {
            width: 16%;
            padding: 0 2%;
          }
        }
        .not-data {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 200px;
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
}
</style>
